import rotowireLogo from 'assets/icons/rotowireLogo.jpg';
import { unitMapping } from 'lib/style';

export const RotowireSmallLogo = ({
  size = 2,
}: {
  size: keyof typeof unitMapping;
}) => <img style={{ width: unitMapping[size] }} src={rotowireLogo} alt="" />;
